import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLoadboardUsersTruckstop extends Layout {
    sourcePbwLoadboardUsers: DataSource;
    tablePbwUserTruckstop: Table;
}
